import React from 'react';
import { useHistory } from 'react-router-dom';
import { EditOutlined, UserOutlined } from '@ant-design/icons';
import {
  GroupCardLink,
  CardImage,
  BadgeRow,
  MemberBadge,
  MemberIconWrap,
  StatusPill,
  CardContent,
  TitleRow,
  GroupTitle,
  GroupDescription,
  EditIconButton,
} from './groupCard.styled';

export interface GroupCardProps {
  editable?: boolean;
  isPending?: boolean;
  /** Account /groups page: dark page layout, image badges, serif title */
  id?: string;
  attributes?: {
    slug?: string;
    coverPhotoUrl?: string;
    name?: string;
    description?: string;
    categories?: {
      data: {
        attributes?: {
          title?: string;
        };
      }[];
    };
    members?: {
      data?: { id?: string }[];
    };
  };
}

export default function GroupCard({
  id,
  editable,
  isPending,
  attributes: { slug, coverPhotoUrl, name, description, categories, members } = {},
}: GroupCardProps) {
  const history = useHistory();
  const plainDescription =
    description
      ?.replace(/<[^>]*>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim() ||
    categories?.data
      ?.map((cat) => cat?.attributes?.title)
      .filter(Boolean)
      .join(', ');
  const memberCount = members?.data?.length || 0;

  const categoryLabels =
    categories?.data
      ?.map((cat) => cat?.attributes?.title)
      .filter(Boolean)
      .join(', ') || '';

  const pendingBadgeLabel = categoryLabels;

  return (
    <GroupCardLink to={isPending ? '#' : `/groups/${slug}`}>
      <CardImage $coverUrl={coverPhotoUrl || ''}>
        <BadgeRow>
          <MemberBadge>
            <MemberIconWrap>
              <UserOutlined />
            </MemberIconWrap>
            {memberCount}
          </MemberBadge>
          {pendingBadgeLabel && (
            <StatusPill>
              <span>{pendingBadgeLabel}</span>
            </StatusPill>
          )}
        </BadgeRow>
      </CardImage>
      <CardContent>
        <TitleRow>
          <GroupTitle>{name}</GroupTitle>
          {editable && (
            <EditIconButton
              type="primary"
              ghost
              onClick={(e: React.MouseEvent) => {
                e.preventDefault();
                history.push(`/groups/update/${id}`);
              }}
            >
              <EditOutlined />
            </EditIconButton>
          )}
        </TitleRow>
        {plainDescription && <GroupDescription>{plainDescription}</GroupDescription>}
      </CardContent>
    </GroupCardLink>
  );
}
